<template>

<div class="p-grid">
  <div class="p-col-12 p-pt-0 p-pb-0">

    <div v-if="recipe" style="overflow-x: hidden; margin: 0rem -2rem;" :class="[{'editing-mode':editing}]">

      <div class="fade-left"/>
      <div class="fade-right"/>

      <Transition name="fade">
        <div v-if="showLeftAddButton" class="phase-add-left">
          <img src="assets/irinox/icons/phase_add.svg" @click="addLeftPhase" :alt="$t('common.add')"/>
        </div>
      </Transition>
      <Transition name="fade">
        <div v-if="showRightAddButton" class="phase-add-right">
          <img src="assets/irinox/icons/phase_add.svg" @click="addRightPhase" :alt="$t('common.add')"/>
        </div>
      </Transition>
      <Transition name="fade">
        <div v-if="showDeleteButton" class="phase-delete">
          <img src="assets/irinox/icons/phase_delete.svg" @click="() => { dialog.delete = true; }" :alt="$t('common.delete')"/>
        </div>
      </Transition>

      <BlockUI :blocked="editingControls" class="blocked-carousel">
      <vueper-slides ref="phases" class="no-shadow ex--center-mode" 
          arrows-outside :bullets="false" 
          transition-speed="250" :infinite="false"
          :dragging-distance="70" 
          :slideRatio="1/1"
          :disableArrowsOnEdges="true"
          @before-slide="beforeSlide()"
          @slide="changeSlide('slide', $event)"
          @ready="carouselReady"
          >      

        <template #arrow-left>
          <img src="assets/irinox/icons/carousel_left.svg"  :alt="$t('common.previous')"/>
        </template>

        <template #arrow-right>
          <img src="assets/irinox/icons/carousel_right.svg"  :alt="$t('common.next')"/>
        </template>

        <vueper-slide
            v-for="(phase, i) in recipe.phases"
            :key="'carousel_phase_'+i"
            :content="JSON.stringify(phase)"
            :style="'background-color: white'" 
            >
          <template #content>

            <div :class="['phase', phaseTypeClass(phase.type)]">

              <div v-if="isSpecialPhase(phase.type)" :class="['phase-header']">{{$t('mf.phases.'+phase.type).toUpperCase()}}</div>
              <div v-else :class="['phase-header']">{{(i).toString().padStart(2, '0')}}. {{$t('mf.phases.'+phase.type).toUpperCase()}}</div>

              <div v-if="(phase.type==2 || phase.type==3)" :class="['phase-body']" @mouseup="phaseSelected(i)" @mousedown="mousedown" @mousemove="mousemove">
                <div class="p-d-flex p-flex-column phase-big p-ai-center p-jc-center">
                  <span v-if="(phase.type==2)" class="icon-prechilling" style="font-size: 80px"/>
                  <span v-if="(phase.type==3)" class="icon-preheating" style="font-size: 80px"/>
                  <span class="p-m-2">{{$functions.temperature(phase.set_temp_room*10,isCelsius)}}{{unit}}</span> 
                </div>
              </div>

              <div v-else-if="(phase.type==4)" :class="['phase-body']" @mouseup="phaseSelected(i)" @mousedown="mousedown" @mousemove="mousemove">
                <div class="p-d-flex p-flex-column phase-big p-ai-center p-jc-center">
                  <span class="icon-air_temp" style="font-size: 80px"/>
                  <span class="p-m-2">{{$functions.temperature(phase.set_temp_room*10,isCelsius)}}{{unit}}</span> 
                </div>
              </div>

              <div v-else-if="(phase.type==8)" :class="['phase-body']" @mouseup="phaseSelected(i)" @mousedown="mousedown" @mousemove="mousemove">
                <div class="p-d-flex p-flex-column phase-big p-ai-center p-jc-center">
                  <span class="icon-fan" style="font-size: 80px"/>
                  <span class="p-m-2">{{phase.set_ventilation}}</span> 
                </div>
              </div>

              <div v-else :class="['phase-body']" @mouseup="phaseSelected(i)" @mousedown="mousedown" @mousemove="mousemove">
                <div> </div>
                <div class="setpoint">
                  <div :class="['p-grid', 'p-ai-center']">
                    <div class="p-col-fixed p-text-center">
                      <span class="icon-air_temp"/>
                    </div>
                    <div class="p-col p-text-right">
                      <span>{{$functions.temperature(phase.set_temp_room*10,isCelsius)}}{{unit}}</span>  
                    </div>
                  </div>
                </div>
                <Divider v-if="isCoreVisible(phase)" />
                <div v-if="isCoreVisible(phase)" class="setpoint">
                  <div :class="['p-grid', 'p-ai-center']">
                    <div class="p-col-fixed p-text-center">
                      <span class="icon-core_temp"/>
                    </div>
                    <div class="p-col p-text-right">
                      <span>{{$functions.temperature(phase.set_temp_probe*10,isCelsius)}}{{unit}}</span>  
                    </div>
                  </div>
                </div>
                <Divider v-if="isDurationVisible(phase)" />
                <div class="setpoint" v-if="isDurationVisible(phase)" >
                  <div :class="['p-grid', 'p-ai-center']">
                    <div class="p-col-fixed p-text-center">
                      <span class="icon-time"/>
                    </div>
                    <div class="p-col p-text-right">
                      <span>{{duration(phase)}}</span> 
                    </div>
                  </div>
                </div>
                <Divider />
                <div class="setpoint">
                  <div :class="['p-grid', 'p-ai-center']">
                    <div class="p-col-fixed p-text-center">
                      <span class="icon-fan"/>
                    </div>
                    <div class="p-col p-text-right">
                      <span>{{phase.set_ventilation}}</span> 
                    </div>
                  </div>
                </div>
                <div> </div>
              </div>

            </div>

          </template>

        </vueper-slide>

      </vueper-slides>
      </BlockUI>

    </div>

  </div>

  <div v-if="editing">

    <IrinoxDialogDark :visible="dialog.delete" mode="confirm" 
      :leftB="$t('library.steps.phases.delete_phase_dialog_cancel')" @click:left-button="() => {dialog.delete = false;}" 
      :rightB="$t('library.steps.phases.delete_phase_dialog_confirm')" @click:right-button="deletePhase" 
      :message="$t('library.steps.phases.delete_phase_dialog')"
      icon="assets/irinox/icons/delete_big.svg" />
    <IrinoxDialogDark :visible="dialog.deleteSuccess" 
      mode="success" 
      :message="$t('library.steps.phases.delete_phase_dialog_deleted')"
      :life="3000" 
      @update:visible="dialog.deleteSuccess = $event" />


    <Dialog :visible="dialog.add" class="phase-add-dialog" :modal="true" 
        :closable="true" :dismissableMask="true" :style="{width: '500px', minWidth: '460px'}" :draggable="false"
        @update:visible="updateVisible">
        
      <template #header class="p-pb-0">{{$t('library.steps.phases.add_phase')}}</template>
      
      <div class="phase-type-selection p-mt-5">

        <div>
          <div v-for="i in selectablePhases" :key="'phase_'+i" @click="newPhaseSelected(i)">
            {{$t('mf.phases.'+(i))}}
          </div>
        </div>

      </div>

      <template #footer></template>
      
    </Dialog>
  
    <!--                    -->
    <!-- ERRORS and SUCCESS -->
    <!--                    -->
    <IrinoxDialogDark :visible="dialog.error" 
      mode="error" 
      :message="$t('library.dialog_error')"
      :life="3000" 
      @update:visible="dialog.error = $event" />

  </div>

</div>

</template>

<script>
import { mapGetters } from 'vuex';
import { VueperSlides, VueperSlide } from 'vueperslides';
import 'vueperslides/dist/vueperslides.css';
import commands from "../../../../../public/json/commands_mf.json";
import defaults from "../../../../../public/json/cycles_mf.json";
import IrinoxDialogDark from '../../../IrinoxDialogDark.vue';
import BlockUI from '../../../BlockUI.vue';

export default {
  emits: ['change:phase','select:phase','remove:phase','add:phase'],
  components: {
      VueperSlides, 
      VueperSlide,
      IrinoxDialogDark,
      BlockUI,
    },
    props: {
      serialNumber: String,
      recipe: Object,
      appliance: Object,
      editing: Boolean,
      editingControls: Boolean
    },
    data() {
        return {
          commands: commands,
          def: defaults.functions[this.recipe.function],
          currentPhase: 0,
          drag: false,
          dialog: {
            delete: false,
            deleteSuccess: false,
            add: false,
            error: false,
          },
          selectablePhases: [],
          slideChanging: false,
        };
    },
    computed: {
      ...mapGetters({
          personaltoken: 'userdata/personaltoken',
          unit: 'userdata/unit',
          isCelsius: 'userdata/isCelsius',
        }),
      limits() {
        return this.commands.functions[this.recipe.function];
      },
      showLeftAddButton() {
        if(this.editing && !this.slideChanging && !this.slideChanging && this.recipe.phases.length<15) {
          let fixedPhase = this.getFixedPhase();
          if(fixedPhase) {
            return fixedPhase.left;
          } else if(this.currentPhase === 0) {
            return false;
          } else {
            return typeof this.getRuleSet(this.currentPhase-1, this.currentPhase) !== 'undefined';
          }
        }
        return false;
      },
      showRightAddButton() {
        if(this.editing && !this.slideChanging && this.recipe.phases.length<15) {
          let fixedPhase = this.getFixedPhase();
          if(fixedPhase) {
            return fixedPhase.right;
          } else if(this.currentPhase===this.recipe.phases.length-1) {
            return false;
          } else {
            return typeof this.getRuleSet(this.currentPhase, this.currentPhase+1) !== 'undefined';
          }
        }
        return false;
      },
      showDeleteButton() {
        if(this.editing && !this.slideChanging) {
          let fixedPhase = this.getFixedPhase();
          if(fixedPhase) {
            return false;
          } else if(this.currentPhase === 0 || this.currentPhase===this.recipe.phases.length-1) {
            return false;
          } else {
            return typeof this.getRuleSet(this.currentPhase-1, this.currentPhase+1) !== 'undefined';
          }
        }
        return false;
      }
    },
    watch: {
    },
    created() {
    },
    mounted() {
    },
    methods: {
      getFixedPhase() {
        if(!this.def.fixedPhases) {
          console.error("FIXED PHASE NOT DEFINED FOR FUNCTION "+this.recipe.function);
          return undefined;
        }
        if(this.currentPhase===this.recipe.phases.length-1) 
          return this.def.fixedPhases["N"];
        return this.def.fixedPhases[this.currentPhase];
      },
      getRuleSet(left, right) {
        let l = this.recipe.phases[left].type;
        let r = this.recipe.phases[right].type;
        if(!this.def.ruleSets) {
          console.error("RULESETS NOT DEFINED FOR FUNCTION "+this.recipe.function);
          return undefined;
        }
        return this.def.ruleSets[l+"-"+r];
      },
      carouselReady() {
        this.$refs.phases.goToSlide(0);
      },
      beforeSlide() {
        this.slideChanging = true;
      },
      changeSlide(eventName, params) {
        // console.log(JSON.stringify(params));
        this.currentPhase = params.currentSlide.index;
        this.$emit("change:phase", params.currentSlide.index);
        setTimeout(function() {
          this.slideChanging = false;
        }.bind(this),300);
      },
      mousedown() {
        this.drag = false;
      },
      mousemove() {
        this.drag = true;
      },
      phaseSelected(index) {
        if(!this.drag) {
          this.$emit("select:phase", index);
        }
      },
      phaseTypeClass(t) {
        if(this.isSpecialPhase(t)) {
          return "phase-special";
        }
        if(t==1) {
          return "phase-hot";
        }
        return "phase-cold";
      },
      isSpecialPhase(t) {
        return (t==2 || t==3 || t==4 || t==7 || t==8);
      },
      isCoreVisible(phase) {
        let p = this.limits.phases[phase.type];
        return (p && p.coreProbeSetTempMin != null && p.coreProbeSetTempMax!=null);
      },
      isDurationVisible(phase) {
        let p = this.limits.phases[phase.type];
        return (p && p.phaseDurationSetMin != null && p.phaseDurationSetMax!=null);
      },
      duration(phase) {
        try {
          //phaseDurationSet is in seconds
          let time = phase.set_duration / 60;
          //time in minutes
          if(time) {
            var hours = Math.floor(time / 60);
            time = time - hours * 60;
            var minutes = Math.floor(time);
            return (hours<10?"0"+hours:hours)+"h:"+(minutes<10?"0"+minutes:minutes)+"m";
          }
        } catch(err) {
          return "N/A";
        }
      },
      deletePhase() {
        this.dialog.delete = false;
        this.$emit('remove:phase', this.currentPhase);
        this.dialog.deleteSuccess = true;
      },
      addLeftPhase() {
        this.addPhaseShift = 0;
        this.selectablePhases = this.getRuleSet(this.currentPhase-1, this.currentPhase);
        this.dialog.add = true;
      },
      addRightPhase() {
        this.addPhaseShift = +1;
        this.selectablePhases = this.getRuleSet(this.currentPhase, this.currentPhase+1);
        this.dialog.add = true;
      },
      newPhaseSelected(type) {
        this.dialog.add = false;
        this.$emit('add:phase', { 
          position: this.currentPhase + this.addPhaseShift, 
          type: type 
        });
        if(this.addPhaseShift > 0) {
          this.$refs.phases.next();
        }
      },
      updateVisible(value) {
        if(!value) {
          this.dialog.add = false;
        }
      },
    }

}
</script>

<style>

</style>